export default function Hero() {
  const platforms = ["iOS", "Android", "Windows", "macOS", "网页版"];

  return (
    <section id="top" className="relative isolate overflow-hidden">
      <div
        className="absolute inset-0 -z-10 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=abstract%20stylized%20comic%20book%20collage%20background%20with%20warm%20orange%2C%20gold%20and%20crimson%20panels%2C%20halftone%20dots%2C%20speed%20lines%2C%20dramatic%20diagonal%20composition%2C%20artistic%20painterly%20texture%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=baozi-hero-bg&orientation=landscape')",
        }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 -z-10 bg-gradient-to-b from-black/55 via-black/45 to-black/60"
        aria-hidden="true"
      />

      <div className="mx-auto flex min-h-[88vh] w-full max-w-7xl flex-col justify-center px-4 pb-20 pt-28 md:px-8 md:pt-32">
        <span className="inline-flex w-fit items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs text-background-100 backdrop-blur">
          <i className="ri-fire-line text-sm text-secondary-300" aria-hidden="true" />
          包子漫画 · 官方入口导航页
        </span>

        <h1 className="mt-5 max-w-3xl font-heading text-3xl leading-tight text-white md:text-5xl">
          包子漫画，网页与客户端都能读的在线漫画平台
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          这里是包子漫画的官方入口导航。你可以在这一页完成三件事：下载各平台客户端、找到当前可用的最新访问地址、直接在网页上打开漫画库追更。不论你习惯用手机、平板还是电脑，都能从同一个入口出发。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#download"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-download-2-line text-base" aria-hidden="true" />
            立即下载客户端
          </a>
          <a
            href="#library"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-6 py-3 text-sm font-medium text-white backdrop-blur transition-colors hover:bg-white/20"
          >
            <i className="ri-book-open-line text-base" aria-hidden="true" />
            先在线看漫画
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-100/80">
          <span className="text-background-100/60">支持客户端：</span>
          {platforms.map((p) => (
            <span key={p} className="inline-flex items-center gap-1.5">
              <i className="ri-check-line text-secondary-300" aria-hidden="true" />
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}